import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Button,
  Card,
  Form,
  Modal,
  Tabs,
  Tab
} from 'react-bootstrap';

import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';
import {
  saveSettings,
  getSetting,
  SM_TRAINING_NOTIFY_WHEN_TRAINING_EXPIRED
} from 'services/base-services/userSettingServices';

/// when change any column in this must recheck in api   UserSetting
/// for example  "\"notifyWhenTrainingExpired\":true" is using to send mail

export default function SkillMatrixSetting() {
  const defaultState = { notifyWhenTrainingExpired: false };
  const [formData, setFormData] = useState(defaultState);
  
  const handleSave = async () => {
    try {
      saveSettings(SM_TRAINING_NOTIFY_WHEN_TRAINING_EXPIRED, JSON.stringify(formData)).then(() => {
      });

      toast.success(
        <BasicTemplate success={true} text="Successfully saved!" />
      );
    } catch (error) {
      console.error('Error saving config:', error);
    }
  };

  const reloadConfig = () => {
     getSetting(SM_TRAINING_NOTIFY_WHEN_TRAINING_EXPIRED, false).then(res => {
      if (res?.data?.settingValue) {
        let settingValue = JSON.parse(res?.data?.settingValue);
        setFormData(settingValue);
      }
    });
  };
  useEffect(() => {
    reloadConfig();
  }, []);

  return (
    <>
      <Row className="g-3 mb-3">
        <Col xs={12}>
          <Card show={true} contentClassName="border" size="lg">
            <Form onSubmit={e => e.preventDefault()}>
              <Card.Header
                closeButton
                className="bg-light px-card border-bottom-0"
              >
                <Card.Title as="h5">Settings</Card.Title>
              </Card.Header>
              <Modal.Body className="p-card">
                <Tabs
                  defaultActiveKey="user-files"
                  id="file-management-tabs"
                  className="mb-3"
                >
                  <Tab eventKey="user-files" title="Settings">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="border rounded p-3 shadow-sm bg-light">
                          <h5 className="mb-3">Training</h5>
                          <div className="d-flex gap-2 mb-3">
                            <Form.Check
                              type="checkbox"
                              name="notifyWhenTrainingExpired"
                              label="Notify When Training Expired"
                              checked={formData?.notifyWhenTrainingExpired}
                              onChange={e =>
                                setFormData({
                                  ...formData,
                                  notifyWhenTrainingExpired: e.target.checked
                                })
                              }
                            />
                          </div>
                          <div className="text-end">
                            <Button variant="primary" onClick={handleSave}>
                              Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </Modal.Body>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
}
